import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fbe946f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headers" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "breadcrumb" }
const _hoisted_4 = { class: "vo-user-info" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("修改密码")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("退出登录")

import { ElTooltip, ElMessageBox } from 'element-plus';
import { useRouter, useRoute } from 'vue-router';
import { useAppStore } from '@/store/app';
import { useCache } from '@/hooks/useCache';
import { Session } from '@/utils/storage';

import Breadcrumb from './breadcrumb.vue';
import { GetSystemCache } from '@/utils/trends.unils';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { replace } = useRouter();
const { wsCache } = useCache();

const login = useAppStore().getLoginInfo;
const logo = require('@/assets/logo/logo.png');

/* 退出登录 */
const onLoginOutBtnClick = () => {
	ElMessageBox.confirm('是否退出合同管理系统？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', lockScroll: false, type: 'warning' }).then(() => {
		wsCache.clear();
		Session.clear();

		useAppStore().setLoginInfo({});
		window.location.reload();
	});
};

const actions = {
	/* 手动刷新一下各个模块缓存 Add by 摸鱼王 2024年3月25日 */
	refeshCache: async () => {
		ElMessageBox.confirm('确定刷新缓存？', '提示', { lockScroll: false, confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(async () => {
			await GetSystemCache();
		});
	},
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Refresh = _resolveComponent("Refresh")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_eiv = _resolveComponent("eiv")!
  const _component_el_header = _resolveComponent("el-header")!

  return (_openBlock(), _createBlock(_component_el_header, { class: "layout-header" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_image, {
            style: {"width":"100%","height":"100%"},
            src: _unref(logo),
            fit: "fit"
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Breadcrumb)
        ]),
        _createVNode(_component_eiv, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_space, {
              wrap: "",
              size: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElTooltip), { content: "刷新缓存" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { size: "18" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Refresh, {
                          onClick: actions.refeshCache
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_unref(login).company_name), 1),
                _createVNode(_component_el_dropdown, { trigger: "click" }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, { command: "pwdModify" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, {
                          command: "loginOut",
                          onClick: onLoginOutBtnClick
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_avatar, { class: "user-avatar" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(`${(_unref(login).user_name || '未知用户').charAt(0)}`), 1)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(`${_unref(login).user_name}(${_unref(login).user_account})`), 1)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})